/* Inline suggestions enhance forms; regular search remains available. */
(() => {
  const forms = new WeakMap();
  let count = 0;
  function setup(input) {
    const form = input.closest('.bk-catalogue-search,.bk-sidebar-search,.search-page-input__parent');
    if (!form || input.name !== 'q') return;
    const existing = forms.get(form);
    if (existing && existing.panel.parentElement === form && existing.input === input) return existing;
    existing?.dispose();
    const listeners = new AbortController();
    const panel = document.createElement('section');
    panel.className = 'bk-suggestions';
    panel.hidden = true;
    const status = document.createElement('p');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    const list = document.createElement('ul');
    list.id = `bk-suggestions-${++count}`;
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', 'Suggested products');
    panel.append(status, list);
    form.append(panel);
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', list.id);
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('autocomplete', 'off');
    const state = {timer: null, controller: null, version: 0, index: -1};
    const close = () => {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      state.index = -1;
    };
    const show = () => { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); };
    async function search() {
      const version = ++state.version;
      state.controller?.abort();
      clearTimeout(state.timer);
      close();
      list.replaceChildren();
      const query = input.value.trim();
      if (!query) return;
      state.timer = setTimeout(async () => {
        state.controller = new AbortController();
        status.textContent = 'Finding products…';
        show();
        try {
          const url = new URL(`${window.Shopify?.routes?.root || '/'}search/suggest.json`, location.origin);
          url.search = new URLSearchParams({q: query, 'resources[type]': 'product', 'resources[limit]': '5'});
          const response = await fetch(url, {signal: state.controller.signal});
          if (!response.ok) throw new Error('Search unavailable');
          const data = await response.json();
          if (version !== state.version) return;
          const products = data.resources?.results?.products || data.suggestions?.resources?.results?.products || [];
          for (const product of products) {
            const target = new URL(product.url, location.origin);
            if (target.origin !== location.origin) continue;
            const item = document.createElement('li');
            item.id = `${list.id}-${list.children.length}`;
            item.setAttribute('role', 'option');
            item.setAttribute('aria-selected', 'false');
            const link = document.createElement('a');
            link.href = target.href;
            const source = product.featured_image?.url || product.image;
            if (source) {
              const img = document.createElement('img');
              img.src = source; img.alt = ''; img.width = 48; img.height = 48;
              link.append(img);
            }
            const label = document.createElement('span');
            label.textContent = product.title.split('|')[0].trim();
            if (product.available === false) label.append(' — Sold out');
            link.append(label); item.append(link); list.append(item);
          }
          status.textContent = list.children.length ? 'Suggested products' : 'No matching products. Try another word or search the catalogue.';
        } catch (error) {
          if (version === state.version && error.name !== 'AbortError') {
            status.textContent = 'Use Search to see all results.';
          }
        }
      }, 220);
    }
    input.addEventListener('input', search, {signal: listeners.signal});
    input.addEventListener('keydown', event => {
      if (panel.hidden) return;
      const items = [...list.children];
      if (event.key === 'Escape') {
        ++state.version; clearTimeout(state.timer); state.controller?.abort(); close();
      } else if (['ArrowDown', 'ArrowUp'].includes(event.key) && items.length) {
        event.preventDefault(); event.stopPropagation();
        state.index = (state.index + (event.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
        items.forEach((item, i) => item.setAttribute('aria-selected', String(i === state.index)));
        input.setAttribute('aria-activedescendant', items[state.index].id);
        items[state.index].scrollIntoView({block: 'nearest'});
      } else if (event.key === 'Enter' && state.index >= 0) {
        event.preventDefault(); event.stopPropagation();
        items[state.index].querySelector('a').click();
      }
    }, {signal: listeners.signal});
    form.addEventListener('focusout', () => setTimeout(() => {
      if (!form.contains(document.activeElement)) {
        ++state.version; clearTimeout(state.timer); state.controller?.abort(); close();
      }
    }, 0), {signal: listeners.signal});
    forms.set(form, {search, panel, input, dispose: () => {
      ++state.version; clearTimeout(state.timer); state.controller?.abort(); listeners.abort(); panel.remove();
    }});
    return forms.get(form);
  }
  document.addEventListener('focusin', event => {
    if (event.target.matches('input[type="search"]')) setup(event.target);
  });
  document.addEventListener('input', event => {
    const input = event.target;
    if (!input.matches('input[type="search"]')) return;
    const form = input.closest('.bk-catalogue-search,.bk-sidebar-search,.search-page-input__parent');
    const existing = form && forms.get(form);
    if (form && (!existing || existing.panel.parentElement !== form || existing.input !== input)) setup(input)?.search();
  });
  document.querySelectorAll('.bk-catalogue-search input[type="search"],.bk-sidebar-search input[type="search"],.search-page-input').forEach(setup);
})();
